import { render, staticRenderFns } from "./InvoiceAuditDetailDialog.vue?vue&type=template&id=5b37ed71&scoped=true"
import script from "./InvoiceAuditDetailDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceAuditDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAuditDetailDialog.vue?vue&type=style&index=0&id=5b37ed71&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37ed71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b37ed71')) {
      api.createRecord('5b37ed71', component.options)
    } else {
      api.reload('5b37ed71', component.options)
    }
    module.hot.accept("./InvoiceAuditDetailDialog.vue?vue&type=template&id=5b37ed71&scoped=true", function () {
      api.rerender('5b37ed71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/InvoiceAuditDetailDialog.vue"
export default component.exports